import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {TermsAcknowledgmentService} from '../../services/terms-acknowledgment.service';
import {MatDialogRef} from '@angular/material/dialog';
import {StringUtils} from '../../utils/string-utils';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-ratings-terms-dialog',
    templateUrl: './ratings-terms-dialog.component.html',
    styleUrls: ['./ratings-terms-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton]
})
export class RatingsTermsDialogComponent {
  private service = inject(TermsAcknowledgmentService);
  private dialogRef = inject<MatDialogRef<RatingsTermsDialogComponent>>(MatDialogRef);


  private textScrollPosition!: number;

  accept(): void {
    this.service.acceptTerms();
    this.dialogRef.close(true);
  }

  decline(): void {
    this.dialogRef.close(false);
  }

  isScrolledToBottom(): boolean {
    if (StringUtils.isEmptyNumericValue(this.textScrollPosition)) {
      return false;
    }
    return this.textScrollPosition <= 2;
  }

  updateScrollPosition(container: HTMLDivElement): void {
    if (!this.isScrolledToBottom()) {
      const viewHeight = container.scrollHeight - container.clientHeight;
      this.textScrollPosition = +(viewHeight - container.scrollTop).toFixed(0);
    }
  }

}
